export class ArchiveApplicationRequest {
  archiveApp: boolean;
}
